export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manarp.ae4ed722.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};